export const ru = {
  common: {
    name: 'Название',
    delete: 'Удалить',
    save: 'Сохранить',
    cancel: 'Отмена',
    unknownError: 'Неизвестная ошибка',
    filter: 'Фильтр',
    apply: 'Применить',
    reset: 'Сбросить',
    restore: 'Восстановить',
    select: 'Выбрать',
    add: 'Добавить',
    accessDenied: 'Доступ запрещен',
  },
  tableActions: {
    edit: 'Редактировать',
    delete: 'Удалить',
    settings: 'Настройки',
  },
  nav: {
    main: 'Главная',
    dynamicCatalogs: 'Динамические справочники',
    singleCatalogs: 'Единые справочники услуг',
    schedule: 'Расписание',
    appointments: 'Записи',
    workers: 'Специалисты',
    patients: 'Пациенты',
    feedback: 'Отзывы клиентов',
    create: 'Создание',
    edit: 'Редактирование',
  },
  catalog: {
    nameId: 'Название / ID',
    listTitle: 'Список справочников',
    addButton: 'Создать справочник',
    create: 'Создание справочника',
    edit: 'Редактирование справочника',
    fieldSettings: 'Настройка полей',
    createEl: 'Создание элемента',
    editEl: 'Редактирование элемента',
    nameEl: 'Название элемента',
    listEl: 'Список элементов',
    addElButton: 'Добавить элемент',
    fieldEdit: 'Редактирование поля',
    fieldType: 'Тип поля',
    fieldCatalog: 'Справочник',
    fieldMulti: 'Множественный выбор',
    fieldReq: 'Обязательное',
    fieldUniq: 'Уникальное',
    displayInGrid: 'Отображать в списке',
    inGrid: 'В списке',
    addField: 'Добавить поле',
    entityField: 'Привязка к сущности',
    bIdListField: 'Список businessId',
    nIdListField: 'Список networkId',
    aclField: 'Права доступа',
    aclCatalogRead: 'Чтение справочника',
    aclCatalogUpdate: 'Изменение конфигурации',
    aclCatalogDelete: 'Удаление справочника',
    aclItemUpdate: 'Изменение элементов',
    aclItemDelete: 'Удаление элементов',
    aclBinding: 'Управление связями',
    aclOther: 'Остальные',
    importSuccess: 'Импорт завершен',
    importWarning: 'Импорт завершен с ошибками. Подробности в консоли браузера',
    tabMain: 'Основное',
    tabBinding: 'Связи',
    tabAlerts: 'Оповещения',
    addBinding: 'Добавить связь с сущностью',
    searchBusiness: 'Поиск филиала по названию или id',
    selectBusiness: 'Выберите филиал',
    selectTaxonomy: 'Выберите услугу',
    selectResource: 'Выберите специалиста',
    businessTitle: 'Филиал',
    entityTitle: 'Сущность',
    errorBidNid: 'businessIdList или networkIdList обязательны к заполнению',
    showInactive: 'Показывать удаленные',
    importItems: 'Импорт элементов',
    exportItems: 'Экспорт элементов',
    importConfig: 'Импорт конфигурации',
    exportConfig: 'Экспорт конфигурации',
    importBindings: 'Импорт привязок',
    exportBindings: 'Экспорт привязок',
    confirmationAlert: 'Подтверждение на виджете',
    confirmationEmailAlert: 'Подтверждение по E-mail',
    useConfirmationSmsAlert: 'Включить подтверждение по SMS',
    confirmationSmsAlert: 'Подтверждение по SMS',
    selectedServiceAlert: 'Уведомление при выборе услуги',
    selectedServiceBlock: 'Блокировать выбор услуги',
  },
}
